<template>
  <div>
    <b-row>
      <b-col cols="12" xl="12">
        <b-form>
          <b-form-group
            label="Nombre:"
            label-for="nombre"
            :label-cols="2"
            horizontal>
            <b-form-input 
              id="nombre" 
              v-model="nombre" 
              type="text">
            </b-form-input>
          </b-form-group>
        </b-form>
      </b-col>      
    </b-row>

    <b-row>
      <b-col cols="12" xl="12">  
        <b-table hover  
            responsive="sm" 
            class="registro"
            :busy="tableBusy"
            :items="personal" 
            :fields="personalFields"
            :filter="nombre"
            :current-page="paginaActual"
            :per-page="registrosPorPagina"
            @filtered="onFiltered"
            @row-clicked="seleccionarPersonal">
          <div slot="table-busy" class="text-center">
            <b-spinner class="table-spinner" label="Spinning" />
          </div>              
        </b-table>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" xl="12">  
        <nav>
          <b-pagination size="sm" 
            :total-rows="totalRegistros" 
            :per-page="registrosPorPagina" 
            v-model="paginaActual" 
            prev-text="Prev." next-text="Prox."/>
        </nav>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: 'PersonalSearchList',
  props: {
    incluirInactivos: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      personal: [],
      personalFields: [
        {
          key: 'nombre',
          label: 'Personal',
          sortable: true
        },
        // {
        //   key: 'razonSocial',
        //   label: 'Razón Social',
        //   sortable: true
        // },
      ],

      loaded: false,
      tableBusy: false,
      /* Info de paginación */
      paginaActual: 1,
      totalPaginas: 1,
      registrosPorPagina: 5,
      totalRegistros: 0,

      nombre: null,
    }
  },
  computed: {
  },
  created() {
    this.getPersonal()
  },  
  methods: {
    getPersonal() {
      let params = {
        incluirInactivos: this.incluirInactivos
      }
      this.tableBusy = true;
      this.$store.dispatch('personel/getList', params)
        .then(() => {
          this.personal = this.$store.getters['personel/list'];
          this.totalRegistros = this.personal.length;
          this.tableBusy = false;
        })
    },
    seleccionarPersonal (item) {
      this.$emit('personalSeleccionado', item)
    },
    onFiltered(filteredItems) {
      this.totalRegistros = filteredItems.length
      this.paginaActual = 1
    }    
  },
}
</script>

<style>
</style>
